var path = 'templates/transcription/diff_dialog.html';
var html = "<md-dialog class=diff-dialog aria-label=差分> <form ng-cloak> <md-toolbar> <div class=md-toolbar-tools> <h2>編集履歴 - {{moment(event.timestamp).format(\"YYYY-MM-DD HH:mm:ss\")}}</h2> <span flex></span> <md-button class=md-icon-button ng-click=close()> <md-icon>close</md-icon> </md-button> </div> </md-toolbar> <md-dialog-content ng-bind-html=diffHtml> </md-dialog-content> </form> </md-dialog> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/templates/transcription/diff_dialog.html
// module id = 61
// module chunks = 0